export default {
    state: {
        name: '',
        code: '',
        oldCode: '',
        address: '',
        type: '',
        property: '',
        IdCardMsg:'',
        chooseType:''
    },
    mutations: {
        update(state, valObj) {
            for (let key in valObj) {
                state[key] = valObj[key];
            }
        }
    },
    actions: {},
    getters: {}
}



// WEBPACK FOOTER //
// ./src/modules/search/store/modules/companyInfo.js